<template>
  <div class="transdata">
    <div class="trans">
      <div class="transCon">
        <div class="transHead itemHead">
          <i></i><span>交易数据</span>
          <span>{{tipsDateTimeRange}}</span>
        </div>
        <div class="transbody">
          <el-table :data="transData" style="width: 100%" border v-loading="loadingTable" @sort-change="val => changeSort(val, transPage, oldtransTableData)">
            <el-table-column prop="date" label="日期" align="center"></el-table-column>
            <el-table-column prop="totalAmount" label="收款金额" align="center" sortable="custom" :formatter="formatMoney"></el-table-column>
            <el-table-column prop="tradeNum" label="收款笔数" align="center" sortable="custom"></el-table-column>
            <el-table-column prop="transactionNum" label="交易笔数" align="center" sortable="custom"></el-table-column>
            <el-table-column prop="refundAmount" label="退款金额" align="center" sortable="custom" :formatter="formatMoney"></el-table-column>
            <el-table-column prop="refundNum" label="退款笔数" align="center" sortable="custom"></el-table-column>
            <el-table-column prop="revenueAmount" label="营收金额" align="center" sortable="custom" :formatter="formatMoney"></el-table-column>
            <el-table-column prop="fee" label="手续费" align="center" v-if="isShowFee" sortable="custom" :formatter="formatMoney"></el-table-column>
            <el-table-column prop="settleAmount" label="结算金额" align="center" v-if="isShowFee" sortable="custom" :formatter="formatMoney"></el-table-column>
          </el-table>
          <el-col :span="24" class="paginationBox">
            <el-pagination
              v-if="transPage.count > 0"
              class="pagination"
              prev-text="上一页"
              next-text="下一页"
              :page-size="transPage.pageSize"
              layout="prev, pager,total,next"
              :total="transPage.count"
              :current-page="transPage.pageNo"
              @current-change="onChangeTransPage"
            >
            </el-pagination>
          </el-col>
        </div>
      </div>
    </div>
    <div class="store">
      <div class="storeCon">
        <div class="storeHead itemHead">
          <i></i><span>门店数据</span>
          <span>{{tipsDateTimeRange}}</span>
        </div>
        <div class="storebody">
          <el-table :data="merchantData" style="width: 100%" border v-loading="loadingTable" @sort-change="val => changeSort(val, storePage, oldmerchantTableData)">
            <el-table-column prop="merchantName" label="门店" align="center"></el-table-column>
            <el-table-column prop="totalAmount" label="收款金额" align="center" sortable="custom" :formatter="formatMoney"> </el-table-column>
            <el-table-column prop="tradeNum" label="收款笔数" align="center" sortable="custom"></el-table-column>
            <el-table-column prop="transactionNum" label="交易笔数" align="center" sortable="custom"></el-table-column>
            <el-table-column prop="refundAmount" label="退款金额" align="center" sortable="custom" :formatter="formatMoney"></el-table-column>
            <el-table-column prop="refundNum" label="退款笔数" align="center" sortable="custom"></el-table-column>
            <el-table-column prop="revenueAmount" label="营收金额" align="center" sortable="custom" :formatter="formatMoney"> </el-table-column>
            <el-table-column prop="fee" label="手续费" align="center" v-if="isShowFee" sortable="custom" :formatter="formatMoney"></el-table-column>
            <el-table-column prop="settleAmount" label="结算金额" align="center" v-if="isShowFee" sortable="custom" :formatter="formatMoney"></el-table-column>
          </el-table>
          <el-col :span="24" class="paginationBox">
            <el-pagination
              v-if="storePage.count > 0"
              class="pagination"
              prev-text="上一页"
              next-text="下一页"
              :page-size="storePage.pageSize"
              layout="prev, pager,total,next"
              :total="storePage.count"
              :current-page="storePage.pageNo"
              @current-change="onChangeStorePage"
            >
            </el-pagination>
          </el-col>
        </div>
      </div>
    </div>
    <div class="customAndPart">
      <div class="customAndPartCon">
        <div class="custom" v-if="isShowCustomTable">
          <div class="customHead itemHead">
            <i></i><span>顾客人数</span>
            <span>{{tipsDateTimeRange}}</span>
          </div>
          <div class="custombody">
            <el-table :data="customData" style="width: 100%" border @sort-change="val => changeSort(val, customPage, oldcustomTableData)">
              <el-table-column prop="date" label="日期" align="center" sortable="custom"></el-table-column>
              <el-table-column prop="newCustomerNum" label="新顾客" align="center" sortable="custom"></el-table-column>
              <el-table-column prop="regularCustomerNum" label="老顾客" align="center" sortable="custom"></el-table-column>
              <el-table-column prop="num" label="总人数" align="center" sortable="custom"></el-table-column>
            </el-table>
            <el-col :span="24" class="paginationBox">
              <el-pagination
                v-if="customPage.count > 0"
                class="pagination"
                prev-text="上一页"
                next-text="下一页"
                :page-size="customPage.pageSize"
                layout="prev, pager,total,next"
                :total="customPage.count"
                :current-page="customPage.pageNo"
                @current-change="onChangecustomPage"
              >
              </el-pagination>
            </el-col>
          </div>
        </div>
        <div class="part">
          <div class="partHead itemHead">
            <i></i><span>收款方式</span>
            <span>{{tipsDateTimeRange}}</span>
          </div>
          <div class="partbody">
            <el-table :data="payWayDate" style="width: 100%" border>
              <el-table-column prop="name" label="方式" align="center"></el-table-column>
              <el-table-column prop="num" label="交易笔数" align="center" ></el-table-column>
              <el-table-column prop="money" label="营业收入" align="center" :formatter="formatMoney"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 新增收银点数据表格 -->
        <div class="part" v-show="cashierData.length !== 0">
          <div class="partHead itemHead">
            <i id="cashierIcon"></i><span>收银点数据</span>
            <span>{{tipsDateTimeRange}}</span>
          </div>
          <div class="partbody">
            <el-table :data="cashierData" style="width: 100%" border
            v-loading="loadingTable" @sort-change="val => changeSort(val, cashierPage, oldcashierTableData)">
              <el-table-column prop="cashierAreaName" label="收银点" align="center"></el-table-column>
              <el-table-column prop="tradeNum" label="收款笔数" align="center" sortable="custom"></el-table-column>
              <el-table-column prop="revenueAmount" label="营业收入" align="center" sortable="custom" :formatter="formatMoney"></el-table-column>
            </el-table>
            <el-col :span="24" class="paginationBox">
              <el-pagination
                v-if="cashierPage.count > 0"
                class="pagination"
                prev-text="上一页"
                next-text="下一页"
                :page-size="cashierPage.pageSize"
                layout="prev, pager,total,next"
                :total="cashierPage.count"
                :current-page="cashierPage.pageNo"
                @current-change="onChangeCashierPage"
              >
              </el-pagination>
            </el-col>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { formatDate } from "@/utils/index";
export default {
  props: {
    tipsDateTimeRange: {
      type: String,
    },
    customTableData: {
      type: Array,
    },
    payWayTableDate: {
      type: Array,
    },
    cashierTableData: {
      type: Array,
    },
    merchantTableData: {
      type: Array,
    },
    transTableData: {
      type: Array,
    },
    tableFeeAndMoney: {
      type: Boolean,
    },
  },
  data() {
    return {
      cashierData: [],
      loadingTable: false,
      storePage: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      customPage: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      cashierPage: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      transPage: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      customData: [],
      payWayDate: [],
      merchantData: [],
      transData: [],
      isShowFee: false,
      oldtransTableData: [],
      oldcashierTableData: [],
      oldcustomTableData: [],
      oldmerchantTableData: [],
      isShowCustomTable: true,
    };
  },
  watch: {
    // 时间限制显示手续费和结算金额
    tableFeeAndMoney: {
      handler(val) {
        this.isShowFee = val;
      },
    },
    // 交易数据
    transTableData: {
      handler(val) {
        if (val) {
          this.oldtransTableData = val;
          const len = val.length;
          this.transPage.count = len;
          this.transPage.pageNo = 1;
          const start = (this.transPage.pageNo - 1) * 10;
          const end = this.transPage.pageNo * 10;
          this.transData = val.slice(start, end);
        }
      },
    },
    // 顾客人数
    customTableData: {
      handler(val) {
        if (val) {
          this.oldcustomTableData = val;
          const len = val.length;
          this.customPage.count = len;
          this.customPage.pageNo = 1;
          const start = (this.customPage.pageNo - 1) * 10;
          const end = this.customPage.pageNo * 10;
          this.customData = val.slice(start, end);
          const timeArr = this.tipsDateTimeRange.split("~");
          const nowDate = new Date().getTime();
          // 获取今天的日期,如果开始时间和结束时间都是今天，那就隐藏顾客人数的图表
          /* eslint-disable-next-line */
          timeArr[0] = timeArr[0].replace(/^\s*|\s*$/g, "");
          timeArr[1] = timeArr[1].replace(/^\s*|\s*$/g, "");
          if (timeArr[0] === formatDate(nowDate) && timeArr[1] === formatDate(nowDate)) {
            this.isShowCustomTable = false;
          } else {
            this.isShowCustomTable = true;
          }
        }
      },
    },
    // 收款方式
    payWayTableDate: {
      handler(val) {
        if (val) {
          this.payWayDate = val;
        }
      },
    },
    // 收银点数据
    cashierTableData: {
      handler(val) {
        if (val) {
          this.oldcashierTableData = val;
          const len = val.length;
          this.cashierPage.count = len;
          this.cashierPage.pageNo = 1;
          const start = (this.cashierPage.pageNo - 1) * 10;
          const end = this.cashierPage.pageNo * 10;
          this.cashierData = val.slice(start, end);
        }
      },
    },
    // 门店数据
    merchantTableData: {
      handler(val) {
        if (val) {
          this.oldmerchantTableData = val;
          const len = val.length;
          this.storePage.count = len;
          this.storePage.pageNo = 1;
          const start = (this.storePage.pageNo - 1) * 10;
          const end = this.storePage.pageNo * 10;
          this.merchantData = val.slice(start, end);
        }
      },
    },
  },
  methods: {
    formatMoney(row, column, cellValue) {
      return cellValue / 100;
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeStorePage(page) {
      this.storePage.pageNo = page;
      const start = (this.storePage.pageNo - 1) * 10;
      const end = this.storePage.pageNo * 10;
      this.merchantData = this.merchantTableData.slice(start, end);
    },
    onChangeCashierPage(page) {
      this.cashierPage.pageNo = page;
      const start = (this.cashierPage.pageNo - 1) * 10;
      const end = this.cashierPage.pageNo * 10;
      this.cashierData = this.cashierTableData.slice(start, end);
    },
    onChangeTransPage(page) {
      this.transPage.pageNo = page;
      const start = (this.transPage.pageNo - 1) * 10;
      const end = this.transPage.pageNo * 10;
      this.transData = this.transTableData.slice(start, end);
    },
    onChangecustomPage(page) {
      this.customPage.pageNo = page;
      const start = (this.customPage.pageNo - 1) * 10;
      const end = this.customPage.pageNo * 10;
      this.customData = this.customTableData.slice(start, end);
    },

    pcompare(prop, rev) {
      // 第二个参数没有传递，默认升序排序
      if (rev === undefined) {
        rev = 1;
      } else {
        rev = rev ? 1 : -1;
      }
      return (obj1, obj2) => {
        const val1 = obj1[prop];
        const val2 = obj2[prop];
        return val1 < val2 ? rev * -1 : rev * 1;
      };
    },
    changeSort(column, page, noSortData) {
      page.pageNo = 1;
      this.orderData(column, noSortData);
    },
    orderData(column, noSortData) {
      // 获取原始数据
      let array = noSortData;
      if (column.order === "ascending") {
        array = array.sort(this.pcompare(column.prop, true));
      } else if (column.order === "descending") {
        array = array.sort(this.pcompare(column.prop, false));
      } else if (column.order === null) {
        array = array.sort(this.pcompare('date', true));
      }
      // const newArray = array.slice((page - 1) * 10, page * 10);
      return array;
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
.transdata {
  .itemHead {
    margin-bottom: 30px;
    #cashierIcon {
      background: url("../../../assets/images/report/Survey.png") no-repeat;
      background-size: 100%;
    }
    i {
      width: 24px;
      height: 24px;
      display: inline-block;
      vertical-align: middle;
    }
    span {
      color: #333333;
      font-size: 18px;
      margin-left: 13px;
      vertical-align: middle;
    }
  }
  .trans {
    background: #f7f7f7;
    overflow: hidden;
    .transCon {
      padding: 30px 50px 40px;
      margin-top: 20px;
      background: #fff;
      overflow: hidden;
    }
    .transHead {
      i {
        background: url("../../../assets/images/report/collectamount.png") no-repeat;
        background-size: 100%;
      }
    }
    .transbody {
    }
  }
  //门店数据
  .store {
    background: #f7f7f7;
    overflow: hidden;
    .storeCon {
      padding: 30px 50px 40px;
      margin-top: 20px;
      background: #fff;
      overflow: hidden;
    }
    .storeHead {
      i {
        background: url("../../../assets/images/report/storeCom.png") no-repeat;
        background-size: 100%;
      }
    }
  }

  //顾客人数和活动
  .customAndPart {
    background: #f7f7f7;
    overflow: hidden;
    .customAndPartCon {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
    }
    .custom {
      background: #fff;
      padding: 30px 50px 40px;
      width: 49%;
      .customHead {
        i {
          background: url("../../../assets/images/report/custom.png") no-repeat;
          background-size: 100%;
        }
      }
    }
    .part {
      width: 49%;
      background: #fff;
      padding: 30px 50px 40px;
      .partHead {
        i {
          background: url("../../../assets/images/report/active.png") no-repeat;
          background-size: 100%;
        }
        span {
          margin-top: 3px;
          display: inline-block;
        }
      }
    }
  }
  .paginationBox:last-child{
    text-align: center;
  }
}
</style>
